import api from "./api";

const logAll = (limit) => {
  return api.get("logs?limit="+limit);
};

const logDetail = (boardId, limit) => {
  return api.get("logs/" + boardId + "?limit="+limit);
};

const logCache = () => {
  return api.get("logs/cache/status");
}

const logService = {
  logAll,
  logDetail,
  logCache,
};

export default logService;
